'use strict';

var ActionTypes = require('../constants/ActionTypes'),
    AppDispatcher = require('../AppDispatcher'),
    ImageUploader = require('../utils/ImageUploader'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    { camelizeKeys } = require('humps'),
    { post } = require('../utils/APIUtils'),
    createTokenSource = require('cancellation');

var tokenSources = {},
    CANCEL_REASON = {};

function uploadMediaThumbnail(sectionId, thumbnailUrl) {
  if (tokenSources[sectionId]) {
    tokenSources[sectionId].cancel(CANCEL_REASON);
  }

  tokenSources[sectionId] = createTokenSource();

  AppDispatcher.handleViewAction({
    type: ActionTypes.UPLOAD_MEDIA_THUMBNAIL,
    sectionId: sectionId,
    thumbnailUrl: thumbnailUrl
  });

  ImageUploader
    .uploadFromUrl(thumbnailUrl, tokenSources[sectionId].token)
    .then(function (image) {
      AppDispatcher.handleServerAction({
        type: ActionTypes.UPLOAD_MEDIA_THUMBNAIL_SUCCESS,
        image: image,
        sectionId: sectionId
      });
    })
    .catch(function (err) {
      if (err === CANCEL_REASON) {
        return;
      }

      AppDispatcher.handleServerAction({
        type: ActionTypes.UPLOAD_MEDIA_THUMBNAIL_ERROR,
        sectionId: sectionId,
        error: err
      });
    });
}

var MediaActionCreators = {
  requestMediaData(sectionId, url) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.REQUEST_MEDIA_DATA,
      sectionId: sectionId
    });

    post('/api/media', { url: url }, this.handleMediaData.bind(this), sectionId);
  },

  handleMediaData(err, response, sectionId) {
    var data,
        uploadUrl;

    if (response) {
      data = camelizeKeys(response);

      if (data.background) {
        // Upload thumbnail to our server, clear external URL out of data
        uploadUrl = getThumbnailUrl(data.background, {
          width: 1024,
          height: 1024
        });

        data.background = null;
      }
    }

    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_MEDIA_DATA_ERROR : ActionTypes.REQUEST_MEDIA_DATA_SUCCESS,
      data: data,
      sectionId: sectionId
    });

    if (err) {
      var alertId = err.body;
      AlertActionCreators.showAlert(alertId);
    } else if (uploadUrl) {
      uploadMediaThumbnail(sectionId, uploadUrl);
    }
  }
};

module.exports = MediaActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/MediaActionCreators.js
 **/